import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 12 5 3-5 3v-6Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListVideo";
const ListVideo = memo(themed(Icon));
export {
  ListVideo
};
//# sourceMappingURL=list-video.js.map
